module.exports = __webpack_public_path__ + "img/Katarzyna.cc7d4855.jpg";